// MentionInput.js
import React from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import './mentionInput.css'; // Optional: Create this CSS file for custom styles

export const MentionInputBox = React.memo(
  ({
    label,
    name,
    value = '',
    placeholder,
    onChange,
    required = false,
    disabled = false,
    mentionsData = [
      { id: 'mlno', display: 'MLNO' },
      { id: 'cod', display: 'ConD' },
    ],
    ...rest
  }) => {
    const handleChange = (event) => {
      const syntheticEvent = {
        target: {
          name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    };

    return (
      <div className="form-group">
        <label htmlFor={name}>
          {label}
          {required && '*'}
        </label>
        <MentionsInput
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder || label}
          disabled={disabled}
          className="mentions"
          {...rest}
        >
          <Mention
            trigger="@"
            data={mentionsData}
            markup="@__id__"
            displayTransform={(id) => `@${id}`}
          />
        </MentionsInput>
      </div>
    );
  }
);
